import * as $ from 'jquery';
import { productReportRequest } from '../api/api_product';

export const productReport = () => {
    const producttId = parseInt(document.getElementById('product-sheet')?.dataset.idProduct),
          reportProductBtn = document.querySelector('.js-report-product-btn'),
          reportProductText = reportProductBtn?.querySelector('span'),
          reportProductAlert = document.querySelector('.js-report-product-alert');

    if (reportProductBtn && reportProductAlert) {
        reportProductBtn.addEventListener('click', () => {
            const reportProductModal = document.getElementById('modal-report-product');
            const reportProductConfirm = reportProductModal?.querySelector('.js-report-product-confirm')
            $(reportProductModal).modal('show');

            reportProductConfirm && reportProductConfirm.addEventListener('click', () => {
                productReportRequest(producttId)
                    .then(response => {
                        if (response.ok === true) {
                            $(reportProductModal).modal('hide');
                            reportProductText.textContent = "Publicación reportada";
                            reportProductBtn.disabled = true;
                            reportProductAlert.classList.remove('d-none');
                            reportProductAlert.classList.add('show');
                            $(reportProductModal).on('hidden.bs.modal', () => {
                                window.scroll({
                                    top: 0,
                                    behavior: 'smooth'
                                });
                            });
                        } else {
                            console.error(`Error on productReportRequest with status ${response.status}`)
                        }
                    })
            })
        });
    }
}